module.exports = __webpack_public_path__ + "static/media/pins2-color.78386dca.jpg";